import React from "react";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import { FINISH_STEP } from "../constants/testIds";

export const FinishStep: React.FC = () => {
  const formatMessage = useFormatMessage();
  return (
    <Grid container={true} direction="column" spacing={16} data-testid={FINISH_STEP}>
      <Grid container={true}>
        <Typography variant="body1" component="h3">
          {formatMessage("reviews.reviewFinished.title")}
        </Typography>
      </Grid>
      <Grid container={true}>
        <Typography>{formatMessage("reviews.reviewFinished.message")}</Typography>
      </Grid>
    </Grid>
  );
};
